import { toast } from 'react-toastify';
import {
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE,
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
    AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
    COMPANY_MASTER_USERFORM_RESET,
    CREATE_COMPANY_MASTER_FAILURE,
    CREATE_COMPANY_MASTER_REQUEST,
    CREATE_COMPANY_MASTER_SUCCESS,
    CREATE_USER_FORM_COMPANY_MASTER,
    FETCH_COMPANY_MASTER_FAILURE,
    FETCH_COMPANY_MASTER_REQUEST,
    FETCH_COMPANY_MASTER_SUCCESS,
    FETCH_SINGLE_COMPANY_MASTER_FAILURE,
    FETCH_SINGLE_COMPANY_MASTER_REQUEST,
    FETCH_SINGLE_COMPANY_MASTER_SUCCESS,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
    PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
    UPDATE_COMPANY_MASTER_REQUEST,
    UPDATE_COMPANY_MASTER_SUCCESS,
    UPDATE_COMPANY_MASTER_FAILURE,
    NAVIGATE_UNIT_MASTER,
    NAVIGATE_COMPANY_MASTER,
    DELETE_COMPANY_MASTER_REQUEST,
    DELETE_COMPANY_MASTER_SUCCESS,
    DELETE_COMPANY_MASTER_FAILURE,
    IMAGE_UPLOAD_COMPANY_MASTER_REQUEST,
    IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS,
    IMAGE_UPLOAD_COMPANY_MASTER_FAILURE,
    FETCH_LOGO_COMPANY_MASTER_REQUEST,
    FETCH_LOGO_COMPANY_MASTER_SUCCESS,
    FETCH_LOGO_COMPANY_MASTER_FAILURE,
} from './companyMaster.actionsType';

export const COMPANY_MASTER = 'companyMaster';

let initialState = {
    loading: false,
    companyMaster: [],
    userform: {},
    propertyList: {},
    areaList: {},
    selectedCompany: {},
    isUnitMaster: false,
    companyId: null,
    companyName: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let companyMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;
    switch (type) {
        case FETCH_COMPANY_MASTER_REQUEST:
        case PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST:
        case AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST:
        case CREATE_COMPANY_MASTER_REQUEST:
        case FETCH_SINGLE_COMPANY_MASTER_REQUEST:
        case FETCH_LOGO_COMPANY_MASTER_REQUEST:
        case UPDATE_COMPANY_MASTER_REQUEST:
        case DELETE_COMPANY_MASTER_REQUEST:
        case IMAGE_UPLOAD_COMPANY_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_LOGO_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading:false,
                companylogo: updatePayload
              
            }
        case FETCH_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                companyMaster: updatePayload
            };
        case PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                propertyList: updatePayload
            };
        case AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                areaList: updatePayload.map((item) => {
                    return {
                        fldId: item?.fldId,
                        country: item?.fldCountry,
                        state: item?.fldState,
                        city: item?.fldCity,
                        area: item?.fldArea,
                        pincode: item?.fldPincode,
                        fldStateCode: item?.fldStateCode
                    };
                })
            };
        case IMAGE_UPLOAD_COMPANY_MASTER_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }

        case CREATE_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompany: updatePayload,
                userform: {
                    unitType: updatePayload?.fldFKUnitCategory.toString(),
                    code: updatePayload?.fldCode,
                    shortName: updatePayload?.fldShortName,
                    name: updatePayload?.fldName,
                    address1: updatePayload?.fldAddress1,
                    address2: updatePayload?.fldAddress2,
                    area: updatePayload?.fldFKArea.toString(),
                    gstNo: updatePayload?.fldGSTNo,
                    panNo: updatePayload?.fldPANNo,
                    CName: updatePayload?.fldContactPerNme,
                    mobile: updatePayload?.fldMobileNo,
                    mail: updatePayload?.fldMailId,
                    attachment: updatePayload?.fldImagePath?.toString()
                }
            };
        case UPDATE_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedCompany: {},
                userform: {}
            };
        case DELETE_COMPANY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                propertyList: {},
                areaList: {},
                selectedCompany: {}
            };
        case FETCH_COMPANY_MASTER_FAILURE:
        case PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE:
        case AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE:
        case FETCH_SINGLE_COMPANY_MASTER_FAILURE:
        case FETCH_LOGO_COMPANY_MASTER_FAILURE:
        case CREATE_COMPANY_MASTER_FAILURE:
        case UPDATE_COMPANY_MASTER_FAILURE:
        case DELETE_COMPANY_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case IMAGE_UPLOAD_COMPANY_MASTER_FAILURE: {
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        }
        case CREATE_USER_FORM_COMPANY_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [updatePayload.key]: updatePayload.value
                }
            };
        case COMPANY_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {}
                // propertyList: {},
                // areaList: {},
                // selectedCompany: {}
            };
        case NAVIGATE_UNIT_MASTER:
            return {
                ...state,
                isUnitMaster: true,
                companyId: payload?.companyId,
                companyName: payload?.companyName,
                company: payload?.SelectedItemData
            };
        case NAVIGATE_COMPANY_MASTER:
            return {
                ...state,
                isUnitMaster: false
            };
        default:
            return state;
    }
};
